<template>
  <div class="flex flex-1 flex-col">
    <vx-card title="Перерасчет" class="vx-card_full-height">
      <div class=" flex flex-1 flex-col">
        <ag-grid-table
                :columns="recalculationsColumns"
                noDataText="Перерасчетов нет"
                :getData="updateData"
        />
      </div>
    </vx-card>
  </div>
</template>

<script>
  import AccountNumberRenderer from "@/components/employee/accounts/AccountNumberRenderer";

  export default {
    name: "Recalculation",
    data() {
      return {
        isMounted: false,
        recalculationsColumns: [
          {
            headerName: 'Счет',
            field: 'account_number',
            minWidth: 120,
            sortable: true,
            filter: true,
            pinned: 'left',
            cellRendererFramework: AccountNumberRenderer,
            cellRendererParams: ({data}) => data
          },
          {
            headerName: 'Помещение',
            field: 'number',
            minWidth: 120,
            filter: true,
            sortable: true,
            pinned: 'left',
            valueGetter: ({data}) => data.apartment.number,
          },
          {
            headerName: 'Тариф',
            field: 'tarifs',
            minWidth: 200,
            flex: 2,
            filter: true,
            valueGetter: ({data}) => data.tarifs ? data.tarifs.name : "Неизвестный",
          },
          {
            headerName: 'Месяц',
            field: 'month',
            minWidth: 120,
            filter: true,
            valueGetter: ({data}) => {
              return this.$options.filters.moment(this.$parseDateFromString(data.month), 'MMMM YYYY');
            },
          },
          {
            headerName: 'Сумма',
            minWidth: 100,
            field: 'sum',
            filter: "agNumberColumnFilter",
            valueGetter: ({data}) => data.sum ? Number(data.sum) : 0,
          },
          {
            headerName: 'Основание',
            field: 'comment',
            filter: true,
            cellRenderer: (cell) => {
              return `<span title="${cell.value === null ? '' : cell.value}">${cell.value}</span>`;
            },
            minWidth: 300,
            flex: 2,
          },
          {
            headerName: 'Автор',
            field: 'who',
            filter: true,
            minWidth: 160,
            valueGetter: ({data}) => data.who ? data.who.name : 'Не известно',
          },
        ],
        recalculationTypes: [
          {
            value: 0,
            label: 'Фиксированная сумма на лицевой счет'
          },
          {
            value: 1,
            label: 'По площади'
          },
          {
            value: 2,
            label: 'По постоянно зарегистрированным'
          },
          {
            value: 3,
            label: 'По фактически проживающим'
          },
          {
            value: 4,
            label: 'Перерасчет на сумму начислений'
          }
        ],
        tariffs: [],
        apartmentsTypes: [],
        recalculationsRows: [],
      }
    },
    computed: {
      groupId() {
        return this.$route.params.id;
      },
      selectedHouseId() {
        return this.$store.getters['appUser/selectedHouse'].id;
      }
    },
    methods: {
      onCellClicked(event) {
        if (event.colDef.field === 'apartment' && !event.rowPinned) {
          this.$router.push({name: 'uc_b_account', params: {id: event.data.apartment.account_number}});
        }
      },
      updateData() {
        return new Promise(async resolve => {
          let {data} = await this.$http.get('recalculation', {
            params: {
              group_id: this.groupId,
              buildings_id: this.selectedHouseId,
            }
          });
          resolve(data);
        });
      },
      async getTariffs() {
        let {data} = await this.$http.get('tarifs', {
          params: {
            apartments_type: this.newRecalculation.apartments_type,
            buildings_id: this.newRecalculation.buildingsId
          }
        });
        this.tariffs = data;
      },
      async getApartmentsTypes() {
        try {
          let {data} = await this.$http.get('apart_types');
          this.apartmentsTypes = data;
        } catch (e) {
          this.apartmentsTypes = [];
        }
      },
      getRecalculationTypeById(typeId) {
        let type = this.recalculationTypes.find(type => type.value === typeId);
        return type ? type.label : 'Не известный';
      },
    },
    mounted() {
      this.getApartmentsTypes();
    },
  }
</script>